import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router-dom';
import { Grid } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SecurityIcon from '@mui/icons-material/Security';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

export default function MobileMenu() {
  const quickActions = [
    {
      id: 'deposit',
      label: 'Deposit',
      icon: <ArrowDownwardIcon />,
      iconColor: '#4caf50', // Green
      route: '/receive'
    },
    {
      id: 'withdraw',
      label: 'Withdraw',
      icon: <ArrowUpwardIcon />,
      iconColor: '#ff6b35', // Orange
      route: '/send-coin'
    },
    {
      id: 'stake',
      label: 'Stake',
      icon: <TrendingUpIcon />,
      iconColor: '#9c27b0', // Purple
      route: '/package/Stake Assets'
    },
    {
      id: 'connect-wallet',
      label: 'Connect Wallet',
      icon: <SecurityIcon />,
      iconColor: '#03a9f4', // Light Blue
      route: '/connect-wallet'
    },
    {
      id: 'swap',
      label: 'Swap',
      icon: <SwapHorizIcon />,
      iconColor: '#ffc107', // Yellow/Amber
      route: '/swap-coin'
    }
  ];

  // Uniform color for all buttons - using dark grey to match the design
  const buttonColor = '#2a2a2a';

  return (
    <Box sx={{ paddingX: '16px', marginTop: '24px', marginBottom: '24px' }}>
      <Typography 
        sx={{
          textAlign: 'center',
          fontSize: '14px',
          fontWeight: '600',
          color: 'white',
          fontFamily: 'sans-serif',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          marginBottom: '16px'
        }}
      >
        QUICK ACTIONS
      </Typography>
      
      <Grid container spacing={2}>
        {quickActions.map((action) => (
          <Grid item xs={4} key={action.id}>
            <Box 
              component={RouterLink} 
              to={action.route}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: buttonColor,
                borderRadius: '12px',
                padding: '20px 12px',
                textDecoration: 'none',
                color: 'white',
                minHeight: '100px',
                transition: 'transform 0.2s, backgroundColor 0.2s',
                '&:hover': {
                  transform: 'scale(1.05)',
                  backgroundColor: '#3a3a3a'
                }
              }}
            >
              <Box 
                sx={{
                  fontSize: '32px',
                  marginBottom: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: action.iconColor
                }}
              >
                {action.icon}
              </Box>
              <Typography 
                sx={{
                  fontSize: '12px',
                  fontFamily: 'sans-serif',
                  fontWeight: '500',
                  textAlign: 'center'
                }}
              >
                {action.label}
              </Typography>
            </Box>
          </Grid>
        ))}
        {/* Empty slot for 6th position */}
        <Grid item xs={4}></Grid>
      </Grid>
    </Box>
  );
}
